import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { makeIndexArray } from '~/utils';

export default function MyPageCharacterListSkeleton() {
  return (
    <ul
      css={css`
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 8px;
      `}
    >
      {makeIndexArray(6).map((el) => (
        <Wrapper key={el} />
      ))}
    </ul>
  );
}

const Wrapper = styled.li`
  background: ${({ theme }) => theme.backgroundColor.bg_dark_2};
  ${({ theme }) => theme.mixins.aspectRatio.ratio5_6};
`;
